import styles from './FilterLayout.module.scss'
import { SelectOption } from '../../../types';
import Search from 'src/components/search/unit-search/UnitSearch';
import Button from 'src/components/button/Button';
import UnitSelectMulti from 'src/components/select-multi/unit-select/UnitSelectMulti';
import IconRotating from 'src/assets/icons/rotating_arrow.svg?react';
import { countryOptions, contentOptions } from '@src/constants';
import Select from '@src/components/select/Select';

type Props = {
    country: string
    keyword: string
    content: string
    handleChangeSearch: (value: string) => void
    handleChangeFilter: (value: string[]) => void;
    handleChangeContent: (option: SelectOption) => void
    handleChangeCountry: (option: SelectOption) => void
    handleRemoveAllUnits: () => void
    handleAddAllUnits: () => void
    handleResetFilters: () => void
    hideCourse?: boolean;
    courses: string[]
    setCourses: (courses: string[]) => void
    coursesOptions: SelectOption[]
    isAusCourse?: boolean;
}

function FilterLayout(props: Props) {
    const { keyword, country, content, courses, coursesOptions, isAusCourse, handleChangeContent, handleChangeCountry, handleResetFilters, handleChangeSearch, handleChangeFilter } = props

    return (
        <div className={styles.filterBanner}>
        <div className={isAusCourse ? styles.opReelFilters : styles.filters}>
          <Search placeholder="Search ..." onChange={handleChangeSearch} value={keyword} />
          {isAusCourse ? 
            <Select showSearch={false} doNotSort inline={false} value={content} onChange={handleChangeContent} placeholder={'Uints/Lessons'}
              label={'Units/Lessons'} options={contentOptions} /> : null}
          {isAusCourse ? 
            <Select showSearch={false} inline={false} value={country} onChange={handleChangeCountry} placeholder={'Country'}
              label={'Country'} options={countryOptions} /> : null}
          {
            <UnitSelectMulti inline={false} label={'Course'}
              options={coursesOptions}
              onChange={handleChangeFilter}
              value={courses}
            />
          }
          <Button onClick={handleResetFilters} className={styles.resetBtn} label={'Reset'}
            size={'extraSmall'} outline={true} color={'green'}
            leftIcon={<IconRotating className={styles.resetIcon} />} />
        </div>
        {/* <div className={styles.actions}>
          <div className={styles.clearButton} onClick={handleRemoveAllUnits}>Clear All<ArrowDownIcon className={styles.filterIcon} /></div>
          <div className={styles.addButton} onClick={handleAddAllUnits}>Add All<ArrowDownIcon className={styles.filterIconUp} /></div>
        </div> */}
      </div>
    )
}

export default FilterLayout